import { createValidationConfiguration } from "client/Validation";
import {
	isNotEmpty,
	isNotNullNorUndefined,
	isTrue,
	isUrl
} from "client/Validation/rules";
import {
	SingleSignOnConfigurationMode,
	SingleSignOnFormData
} from "./SingleSignOnSettingsControl";
import { localize } from "client_legacy/ndaw/culture";
import {
	CustomSignOutRedirectUrlActionType,
	SingleSignOnType
} from "client/Api/SingleSignOnSettings/singleSignOnSettings";

export const ssoSettingsValidationConfiguration = createValidationConfiguration<SingleSignOnFormData>();

const oauth2Configuration = ssoSettingsValidationConfiguration.when(x => x.singleSignOnType === SingleSignOnType.OAuth2)
	.forObject("oauth2");

const manualOauth2Configuration = oauth2Configuration.when(x => x.mode === SingleSignOnConfigurationMode.Manual)
	.forObject("manual");

manualOauth2Configuration.forScalar("authority")
	.add(
		isNotNullNorUndefined(),
		isNotEmpty(),
		isUrl({
			allowHttpsOnly: true
		})
	);

manualOauth2Configuration.forScalar("clientId")
	.add(
		isNotNullNorUndefined(),
		isNotEmpty()
	);

manualOauth2Configuration.forObject("key")
	.when(x => x.containsNewValue)
	.forScalar("value")
	.add(
		isNotNullNorUndefined(),
		isNotEmpty()
	);

manualOauth2Configuration.forScalar("wasVerifyClickedAtleastOnce")
	.add(
		isTrue(localize("_YouNeedToVerifyTheOAuth2SettingsBeforeYouCanContinue"))
			.activateOn("formSubmit")
	);

manualOauth2Configuration.forScalar("isVerified")
	.add(
		isTrue()
			.activateOn("formSubmit")
	);

const automaticOauth2Configuration = oauth2Configuration.when(x => x.mode === SingleSignOnConfigurationMode.Automatic)
	.forObject("automatic");

automaticOauth2Configuration.forScalar("permissionToCreateAzureApplication")
	.add(
		isTrue()
	);

const wsFedConfiguration = ssoSettingsValidationConfiguration.when(x => x.singleSignOnType === SingleSignOnType.WsFederation)
	.forObject("wsFed");

wsFedConfiguration.forScalar("metadataDocumentUrl")
	.add(
		isNotNullNorUndefined(),
		isNotEmpty(),
		isUrl({
			allowHttpsOnly: true
		})
	);

wsFedConfiguration.forObject("signOutRedirectUrlConfiguration")
	.when(x => x.action === CustomSignOutRedirectUrlActionType.Enabled)
	.forScalar("url")
	.add(
		isNotNullNorUndefined(),
		isNotEmpty(),
		isUrl({
			allowHttpsOnly: true
		})
	);
